import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import TestKeyboardInputFormFeedback from './TestKeyboardInputFormFeedback'
import TestKeyboardInputFormFonts from './TestKeyboardInputFormFont'
import TestKeyboardInputFormStyle from './TestKeyboardInputFormStyle'
import type {
  TestKeyboardInputFormBrandType,
  TestKeyboardInputBrandForms,
} from './testKeyboardInputTypes'

const FORM_MAP: TestKeyboardInputBrandForms = {
  [BrandFormEnum.STYLE]: TestKeyboardInputFormStyle,
  [BrandFormEnum.FEEDBACK]: TestKeyboardInputFormFeedback,
  ...(TestKeyboardInputFormFonts as TestKeyboardInputBrandForms),
}

const TestKeyboardInputFormBrand: TestKeyboardInputFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(TestKeyboardInputFormBrand) as typeof TestKeyboardInputFormBrand
